import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import parameters from "../utils/parameters";
import { useTranslation } from "react-i18next";

import ShowQuestion from "../submodule/src/App";

import { getRetrieval } from "../submodule/src/api/RetrievalsApi";
import {
  addQuestion,
  getChats,
  addFeedback,
  addFeedback2,
  matrixMode,
} from "../submodule/src/api/QuestionsApi";

import { addMessage } from "../submodule/src/api/MessagesApi";
import logo from "../assets/cs-logo.png";
import FooterNotice from "../components/FooterNotice";

const QuestionWithRetrieval = () => {
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
  const otherReferences = false;
  const { idRetrieval, id } = useParams();

  useEffect(() => {
    const handleLanguageChange = () => {
      setCurrentLanguage(i18n.language);
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [i18n]);

  return (
    <>
      <div className="w-full sm:w-11/12 mx-auto container">
        <ShowQuestion
          getRetrieval={getRetrieval}
          retrievalId={idRetrieval || parameters.retrieval.retrievalId || null}
          addQuestionRetData={id ? getChats : addQuestion}
          addMessage={addMessage}
          logo={logo}
          otherRefs={otherReferences}
          addFeedback={addFeedback}
          addFeedback2={addFeedback2}
          newApi={true}
          matrix_mode={true}
          addMatrixMode={matrixMode}
          colors={parameters.componentColors}
          allow_files={true}
          language={currentLanguage}
          //extendedReferences={true}
          allowMetadata={true}

        />
      </div>
      <FooterNotice />
    </>
  );
};

export default QuestionWithRetrieval;
